import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from 'store';

import { PrescriptionPaneProps } from './prescriptionPane.types';

const initialState: PrescriptionPaneProps = {
  isLoading: false,
  isOpen: false,
  patientId: '',
  prescriptionId: '',
  staffMemberOrderTeams: undefined
};

const prescriptionPaneSlice = createSlice({
  initialState,
  name: 'prescriptionPane',
  reducers: {
    open: (state, action) => {
      state.isOpen = true;
      if (action.payload.prescriptionId) state.prescriptionId = action.payload.prescriptionId;
      if (action.payload.patientId) state.patientId = action.payload.patientId;
    },
    reset: () => initialState,
    setStaffMemberOrderTeams: (state, action) => {
      if (action.payload.staffMemberOrderTeams) {
        state.staffMemberOrderTeams = action.payload.staffMemberOrderTeams;
      }
    }
  }
});

export const selectPrescriptionPane = (state: RootState) => state.prescriptionPane;

export const { open, reset, setStaffMemberOrderTeams } = prescriptionPaneSlice.actions;

export default prescriptionPaneSlice.reducer;
